import { ITransactionRequest } from "../../ITransactionRequest";

export interface IPluginConfiguration {
    Configuration: IConfiguration;
}

export interface IPluginASOConfiguration {
    ConfigurationIds: string[];
    AsoConfig: IConfiguration;
}

export interface IASOResult {
    Result: IPluginASOConfiguration;
    ExceptionMessage: string | null;
}

export interface IConfiguration {
    OtherControls: IOtherControl[];
    LastUpdateUtc: string;
    Packages: IPackage[];
    UseExpressionCaching: boolean;
    DeliveryTypes: IDeliveryType[];
    AllowMultiDelivery: boolean;
    Impersonation: IImpersonation;
    SendValidations: IExpression[];
    ErrorMessageOverrides: IErrorMessageOverrides[];
    DefaultValues: IDefaultValues;
    DisclosureTrackingMapping: IDisclosureTrackingMapping;
    FormToolTips: ICtrlToolTips[];
    EnableTpo: boolean;
    EnableSolexDocEditor?: boolean;
    ConfigurationIds?: IConfigurationIdEntry[];
}

export interface IDocutechControl {
    EnableForTpoUser: boolean;
}

export interface IPackage extends IDocutechControl {
    Group: string;
    Order: number | null;
    AlternatePackageId?: string;
    ParentPackageId?: string;
    ToolTipText?: string;
    ValidDeliveryTypes: string[];
    AutoSelectWhen: string; // use empty string for no autoselect
    Id: string;
    Caption?: string;
    Enabled?: boolean;
    Expressions?: IExpression[];
    Roles?: string[];
    Users?: any[];
    CustomAttributes?: ICustomAttributes | null;
}

export interface IConfigurationIdEntry {
    Id: string;
    Alias: string;
    Enabled: boolean;
}

export const CONFIG_ID_SELECTOR_CONTROL_ID = 'configurationIdSelector';

export interface IOtherControl extends IDocutechControl {
    ControlBehavior?: string;
    FriendlyName?: string;
    Id?: string;
    Caption?: string;
    Enabled?: boolean;
    Expressions?: IExpression[];
    Roles?: string[];
    Users?: string[];
    CustomAttributes?: ICustomAttributes;
}

export interface IExpression {
    ExpressionName: string;
    ExpressionString: string;
    ExpressionMessage: string;
    Enabled: boolean;
}

export interface IControlEvaluationResult {
    result: boolean;
    controlType: string;
    id: string;
    group: string;
    message: string | null;
    originalExpression: string | null;
    expressionDescription?: string | null;
}

export interface ICustomAttributes {
    IPENVendor: string | null;
    IframeVendor: string | null;
    VerificationVendorType: string | null;
    FormFreeLenderID: string | null;
    SolexDocEditorAttr?: boolean;
}

export interface IDeliveryType extends IDocutechControl {
    Order?: any;
    ToolTipText?: string;
    AutoSelectWhen?: string;
    Id: string;
    Caption?: string;
    Enabled?: boolean;
    Expressions?: IExpression[];
    Roles: any[];
    Users: any[];
    CustomAttributes: ICustomAttributes;
}

export interface IImpersonation {
    ClientCode: string | null;
    EnableImpersonation: boolean;
}

export interface IErrorMessageOverrides {
    ResponseMessage: string;
    ResponseOverride: string;
}

export interface ICtrlToolTips {
    ControlId: string;
    ToolTip: string;
}

export interface IDefaultValues {
    IncludeDocumentData: boolean;
    FulfillmentShippingMethod: string[];
    SaveLoanBeforeDisclosing: string[];
    DefaultEFolder: boolean;
    DefaultDisclosureTracking: boolean;
    PreviewAttachmentsAlways: boolean;
    DisableAccessToEllieMaePortals: boolean;
    AutoRefreshOnFormFocus: boolean;
    AlternatePackageColor: string;
    RequireRefreshBeforeSubsequentSend: boolean;
    EncompassLogTemplate: string;
    RequestTypeAvailability: string;
    DefaultRequestType: string;
}

export interface IDisclosureTrackingMapping {
    IntentToProceed: {
        DocumentIds: number[];
        Ingestion: string;
    };
    AffiliatedBusinessDisclosureDocumentIds: number[];
    CHARMBookletDocumentIds: number[];
    SpecialInfoBookletDocumentIds: number[];
    HELOCBrochureDocumentIds: number[];
    AppraisalDocumentIds: number[];
    AVMDocumentIds: number[];
    HomeCounselingDisclosureDocumentIds: number[];
    HighCostDisclosureDocumentIds: number[];
    ProviderListDocumentIds: number[];
    SafeHarborDocumentIds: number[];
    LoanEstimateDocumentIds: number[];
    ClosingDisclosureDocumentIds: number[];
}